/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as i from "react";
import { GridContext as l } from "../GridClientWrapper.mjs";
import { cloneReactElement as a } from "../utils/index.mjs";
const m = (e) => {
  const t = i.useContext(l);
  if (t.isClient || e.isClient) {
    const n = t.getCellPositionStyle(e.columnPosition);
    return e.children && a(e.children, {
      style: { ...e.style, ...n },
      onContextMenu: t.onContextMenu,
      onChange: t.itemChange,
      selectionChange: (o) => {
        t.selectionChange({
          event: o,
          dataItem: e.dataItem,
          dataIndex: e.rowDataIndex,
          columnIndex: e.columnIndex
        });
      }
    });
  }
  return e.children;
};
export {
  m as GridCustomCellClientContainer
};
